// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".careers-callout{background:#fff;padding:50px}@media(min-width:768px){.careers-callout{padding:75px}}.careers-callout h1{font-weight:600}.careers-callout a{font-weight:900;text-transform:uppercase;color:#fff;background-color:#eb226b;padding:10px 25px;border-radius:5px}", ""]);
// Exports
module.exports = exports;
